var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStage14644498(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "m23.5,23h-5.298l-4.434-4.268c-.349-.35-.796-.568-1.268-.658V6.207l1.623-1.623c.395.262.868.416,1.377.416,1.379,0,2.5-1.121,2.5-2.5s-1.121-2.5-2.5-2.5-2.5,1.121-2.5,2.5c0,.509.154.981.416,1.377l-4.27,4.27c-.195.195-.195.512,0,.707.098.098.226.146.354.146s.256-.049.354-.146l1.646-1.646v10.866c-.471.09-.916.307-1.261.652l-4.441,4.274H.5c-.276,0-.5.224-.5.5s.224.5.5.5h23c.276,0,.5-.224.5-.5s-.224-.5-.5-.5ZM15.5,1c.827,0,1.5.673,1.5,1.5s-.673,1.5-1.5,1.5-1.5-.673-1.5-1.5.673-1.5,1.5-1.5Zm-2.433,18.446l3.692,3.554h-4.259v-3.892c.208.071.405.176.567.339Zm-2.128-.007c.159-.159.354-.263.561-.333v3.893h-4.26l3.699-3.561Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage14644498);
export default __webpack_public_path__ + "static/media/stage_14644498.a344d7a72274577bd72638815540c078.svg";
export { ForwardRef as ReactComponent };